import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useConfigActions } from 'redux/actions/Configs'
import {
  selectConfigsData,
  selectConfigsFetchStatus
} from 'redux/selectors/Configs'

export const useConfigsData = () => {
  return useSelector(selectConfigsData)
}

/**
 * The customer's general configurations, fetched if they have not been read
 * yet.
 *
 * The effect lives here rather than in each consumer, so the in-flight guard
 * is shared and the dependency cannot be forgotten by a copy.
 */
export const useConfigs = () => {
  const { tryGetAllConfigs } = useConfigActions()

  const configs = useSelector(selectConfigsData)
  const fetchStatus = useSelector(selectConfigsFetchStatus)

  useEffect(() => {
    tryGetAllConfigs()
  }, [tryGetAllConfigs])

  return {
    configs,
    error: fetchStatus === 'error',
    loading: fetchStatus === 'idle' || fetchStatus === 'fetching'
  }
}
